module.exports = __webpack_public_path__ + "img/2.f048e27e.png";